import { IDrivingSchoolExam } from '~/rage';
import { createSlice } from '../wrappers';

const initialState = {
	exams: [] as IDrivingSchoolExam[],
	selectedIndex: 0,
	maxIndex: 5,
};

const drivingSchoolSlice = createSlice({
	name: 'drivingSchool',
	initialState,
	reducers: {
		setSelectedIndex: (state, action) => {
			state.selectedIndex = action.payload;
		},
		setSelectedIndexPrev: (state) => {
			const index = state.selectedIndex;
			const maxIndex = state.maxIndex;

			if (index === 0) {
				let newIndex = 1;

				while (state.exams[newIndex - 1].isOwned && newIndex < maxIndex + 1) {
					newIndex = newIndex + 1;

					if (newIndex === maxIndex + 1) {
						state.selectedIndex = 0;
						return;
					}
				}
				state.selectedIndex = newIndex;
				return;
			}

			let newIndex = index > 1 ? index - 1 : index;

			while (state.exams[newIndex - 1].isOwned && newIndex > 0) {
				newIndex = newIndex - 1;

				if (newIndex === 0) {
					state.selectedIndex = index;
					return;
				}
			}

			state.selectedIndex = newIndex;
		},
		setSelectedIndexNext: (state) => {
			const index = state.selectedIndex;
			const maxIndex = state.maxIndex;

			if (index === 0) {
				let newIndex = 1;

				while (state.exams[newIndex - 1].isOwned && newIndex < maxIndex + 1) {
					newIndex = newIndex + 1;

					if (newIndex === maxIndex + 1) {
						state.selectedIndex = 0;
						return;
					}
				}
				state.selectedIndex = newIndex;
				return;
			}

			let newIndex = index < maxIndex ? index + 1 : index;

			while (state.exams[newIndex - 1].isOwned && newIndex < maxIndex + 1) {
				newIndex = newIndex + 1;

				if (newIndex === maxIndex + 1) {
					state.selectedIndex = index;
					return;
				}
			}

			state.selectedIndex = newIndex;
		},
		setExams: (state, action) => {
			state.exams = action.payload;
		},
	},
});

export const {
	setSelectedIndex,
	setSelectedIndexPrev,
	setSelectedIndexNext,
	setExams,
} = drivingSchoolSlice.actions;

export default drivingSchoolSlice.reducer;
